export default __webpack_public_path__ + "static/media/S179.e46a46b7.png";